import { useMMKVBoolean, useMMKVNumber, useMMKVObject, useMMKVString } from 'react-native-mmkv';
import type { MMKV } from 'react-native-mmkv';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Reactive reads and writes against a store from `createStorage`.
 *
 * Upstream these take the store as an optional trailing argument and fall back
 * to MMKV's own shared default instance, whose `set` is unguarded — the crash
 * `createStorage` exists to prevent. Requiring the store makes that fallback
 * unrepresentable, so a call site cannot quietly opt out of the guard.
 */
export const useStorageString = (key: string, storage: MMKV) => useMMKVString(key, storage);

export const useStorageNumber = (key: string, storage: MMKV) => useMMKVNumber(key, storage);

export const useStorageBoolean = (key: string, storage: MMKV) => useMMKVBoolean(key, storage);

export const useStorageObject = <T>(key: string, storage: MMKV) => useMMKVObject<T>(key, storage);
